import React from "react";

const TermsOfService: React.FC = () => {
  return (
    <main style={{ padding: "24px", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Terms of Service</h1>
      <p>
        Welcome to <strong>KunalDoorAndMore</strong>. By using our services, you
        agree to the following terms:
      </p>

      <h2>1. Use of Service</h2>
      <p>
        You may use our WhatsApp services only for lawful purposes and in
        accordance with these Terms.
      </p>

      <h2>2. User Responsibilities</h2>
      <p>
        You agree not to misuse our services or attempt to access them using a
        method other than the interface provided.
      </p>

      <h2>3. Data Usage</h2>
      <p>
        Your data will be processed in accordance with our{" "}
        <a
          href="/privacy-policy"
          rel="noreferrer noopener"
        >
          Privacy Policy
        </a>
        .
      </p>

      <h2>4. Limitation of Liability</h2>
      <p>
        We are not liable for any damages arising from the use of our services.
        Services are provided &quot;as is&quot;.
      </p>

      <h2>5. Termination</h2>
      <p>
        We may suspend or terminate access to our services at any time, without
        prior notice, if you violate these terms.
      </p>

      <h2>6. Governing Law</h2>
      <p>
        These Terms are governed by the laws of India. Any disputes will be
        subject to the jurisdiction of courts in Pune, India.
      </p>

      <h2>7. Contact Us</h2>
      <p>
        If you have any questions about these Terms, please contact us at:{" "}
        <br />
        Email:{" "}
        <a href="mailto:Kunaldoors@gmail.com">Kunaldoors@gmail.com</a>
      </p>
    </main>
  );
};

export default TermsOfService;
